import { PublicLayout } from "@/components/PublicLayout";
import { ShieldCheck } from "lucide-react";

const LAST_UPDATED = "October 21, 2026";

const sections = [
  {
    id: "overview",
    title: "Our 4-Layer Defense",
    body: [
      "Sparkd protects every member with four safety layers that work together, from sign-up to the moment you get home.",
    ],
  },
  {
    id: "didit",
    title: "1. Didit Identity Verification",
    body: [
      "Every member completes biometric liveness and government ID validation through Didit before connecting. Sparkd never stores biometric templates or raw facial geometry; we keep only a cryptographic token and a verified flag.",
    ],
  },
  {
    id: "bye-button",
    title: "2. The \"Bye Button\" Polite Letdown",
    body: [
      "Not feeling it? The Bye Button ends a conversation or match with a respectful, pre-written letdown, so nobody is ghosted and nobody has to explain themselves.",
    ],
  },
  {
    id: "purge",
    title: "3. 6:00 AM Daily Ephemeral Purge",
    body: [
      "Venue check-ins, squad huddle threads, and expired chat tokens are hard-purged every day at 6:00 AM local time and cannot be recovered. Live location expires automatically after 2.5 hours and is never tracked in the background once you check out.",
    ],
  },
  {
    id: "watchdog",
    title: "4. Watchdog Squad Wingman Alerts",
    body: [
      "Arm Squad Watchdog on a night out and your wingmen get tactical alerts if something goes wrong. An SOS encrypts a snapshot (GPS, recent photo, timestamp) that only verified public safety personnel with a valid CAD incident number can open.",
    ],
  },
  {
    id: "report",
    title: "Report a Concern",
    body: [
      "Hate speech, non-consensual recordings, explicit nudity, and stalking lead to immediate termination and device-level bans. Report anything to support@sparkd-app.com or submit a support ticket through this portal.",
    ],
  },
];

export default function Safety() {
  return (
    <PublicLayout>
      <div className="spark-grid-bg border-b border-[#2A313C]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#2A313C] bg-[#1F242D] text-xs uppercase font-semibold tracking-[0.2em] text-[#E11D48]">
            <ShieldCheck className="w-3.5 h-3.5" /> Safety
          </span>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-white" data-testid="safety-title">
            Community &amp; Safety Standards
          </h1>
          <p className="mt-3 text-slate-400">Last updated: {LAST_UPDATED}</p>
        </div>
      </div>

      <article className="max-w-4xl mx-auto px-5 sm:px-8 py-12 space-y-8">
        {sections.map((s) => (
          <section key={s.id} id={s.id} className="scroll-mt-24 rounded-2xl spark-card p-6 sm:p-8" data-testid={`safety-section-${s.id}`}>
            <h2 className="font-heading text-xl sm:text-2xl font-bold text-white mb-4">{s.title}</h2>
            <div className="space-y-3">
              {s.body.map((p, i) => (
                <p key={i} className="text-[#CBD5E1] leading-relaxed text-[15px]">{p}</p>
              ))}
            </div>
          </section>
        ))}
      </article>
    </PublicLayout>
  );
}
